<app-navbar-style-three></app-navbar-style-three>
<div class="bg-image" style="font-family: 'Li Ador Noirrit SemiBold';">
  <!-- Start Page Title Area -->
  <section class="subscribe-wrap-area bg-image" style="background-image: url(../../../../assets/img/school/bg1.jpg);">
    <div class="container">
      <div class="subscribe-wrap-inner-box">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <h3 style="font-family: 'Li Ador Noirrit SemiBold';">যোগাযোগের তথ্য</h3>
              <ul class="footer-contact-info contactFooter">

                <li>
                  <i class="flaticon-email"></i>
                  <span style="font-family: 'Li Ador Noirrit SemiBold';">ই-মেইল</span><ng-container
                    *ngIf="MainData !=null"> <a href="mailto:atsdm106365@gmail.com">{{MainData.
                      Email
                      }}</a></ng-container>

                </li>
                <li>
                  <i class="flaticon-marker"></i>
                  <span style="font-family: 'Li Ador Noirrit SemiBold';">মাদ্রাসার ঠিকানা</span>
                  <a href="#" target="_blank" style="font-family: 'Li Ador Noirrit SemiBold';">ছোট মহেশখালী,মহেশখালী,
                    কক্সবাজার,চট্টগ্রাম</a>
                </li>

                <li>
                  <i class="flaticon-phone-call"></i>
                  <a href="tel:01309106365"
                    style="font-family: 'Li Ador Noirrit SemiBold'; font-size: 18px; font-weight: normal;">01309106365</a>
                </li>
                <!-- <div class="row single-footer-widget">
                 
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <h3 style="font-family: 'Congenial'; text-align: center;">Contact (Office)</h3>
                    <div class="row">
                       <div class="col-lg-6 col-md-6 col-sm-12">
                        
                        <ul class="footer-contact-info contactFooter">
                          <li>
                            <i class="flaticon-phone-call"></i>
                            <a href="tel:+88 01819-498512">{{MainData?.OfficePhone1}}</a>
                          </li>
                         
                        

                         
                        </ul>
                        

                       </div>
                       <div class="col-lg-6 col-md-6 col-sm-12">
                        <ul class="footer-contact-info contactFooter">
                          <li>
                            <i class="flaticon-phone-call"></i>
                            <a href="tel:+88 01933-234575">{{MainData?.OfficePhone2}}</a>
                          </li>
                        
                        </ul>
                        
                       </div>
                    </div>
                    
                  </div>
                </div> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>